import { render, staticRenderFns } from "./MenuCopyDialog.vue?vue&type=template&id=39bdee49&scoped=true"
import script from "./MenuCopyDialog.vue?vue&type=script&lang=js"
export * from "./MenuCopyDialog.vue?vue&type=script&lang=js"
import style0 from "./MenuCopyDialog.vue?vue&type=style&index=0&id=39bdee49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bdee49",
  null
  
)

export default component.exports